import { useEffect, useCallback } from "react";
import { Outlet, useParams, Navigate, useLocation } from "react-router-dom";
import { LangProvider, useLang, getSavedLang } from "../i18n";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";
import { IntroMap } from "./IntroMap";
import { api } from "../lib/api";
import { createContext, useContext, useState } from "react";

const BootContext = createContext(null);
export const useBoot = () => useContext(BootContext);

const Shell = () => {
  const location = useLocation();
  const [boot, setBoot] = useState(null);

  const fetchBoot = useCallback(() => {
    api.get("/public/bootstrap").then((res) => setBoot(res.data)).catch(() => {});
  }, []);

  // Refetch on navigation so CMS edits appear without a manual reload.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    fetchBoot();
  }, [location.pathname, fetchBoot]);

  // Refetch when the tab regains focus (e.g. after editing in the /admin tab).
  useEffect(() => {
    const onFocus = () => fetchBoot();
    const onVisible = () => { if (!document.hidden) fetchBoot(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [fetchBoot]);

  return (
    <BootContext.Provider value={boot}>
      <IntroMap />
      <div className="min-h-screen bg-[#F5F5F3] flex flex-col">
        <Header />
        <main className="flex-1"><Outlet context={boot} /></main>
        <Footer boot={boot} />
        <CookieConsent />
      </div>
    </BootContext.Provider>
  );
};

export const Layout = () => {
  const { lang } = useParams();
  if (lang !== "fr" && lang !== "en") {
    return <Navigate to={`/${getSavedLang()}`} replace />;
  }
  return <LangProvider><Shell /></LangProvider>;
};
